import React, {useEffect, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {RootState} from 'modules';
import {getEditangleAction} from 'modules/getEditangle';
import {isEditangleAction} from 'modules/ui';
import {IVodInfoData} from 'lib/api/vodInfo';
import Editangle from 'components/footer/Editangle';
import {setClickLog} from 'lib/utils';

/**
 * 편집각 컨테이너
 */

let titleNo = 0;

const EditangleContainer = () => {
  const dispatch = useDispatch();
  const {vodData, editangle, editMode} = useSelector(
    ({vodInfo, getEditangle, ui}: RootState) => ({
      vodData: vodInfo.titleFileInfo.data,
      editangle: getEditangle.data.data,
      editMode: ui.editMode,
    }),
  );
  const checkRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (!vodData) return;

    const {response} = vodData as IVodInfoData;
    if (!response.info) return;

    const {title_no} = response.info;
    titleNo = title_no;
  }, [vodData]);

  /**
   * 편집각 노출 체크박스 클릭
   */
  const onClickEditangle = () => {
    if (titleNo === 0) return;

    const checkbox = checkRef.current;
    if (!checkbox) return;

    if (!checkbox.checked) {
      dispatch(isEditangleAction(false));

      let clickLogParam = `button_type=editangle_off&title_no=${titleNo}`;
      if (editMode !== 'section') {
        clickLogParam += `&editor_type=${editMode}_editor`;
      }
      setClickLog(clickLogParam); // 클릭 로그
    } else {
      dispatch(isEditangleAction(true));

      let clickLogParam = `button_type=editangle_on&title_no=${titleNo}`;
      if (editMode !== 'section') {
        clickLogParam += `&editor_type=${editMode}_editor`;
      }
      setClickLog(clickLogParam); // 클릭 로그

      // 한번 데이터 가져왔으면 API 호출 더이상 안함
      if (editangle !== null) return;
      dispatch(
        getEditangleAction.request({
          titleNo,
        }),
      );
    }
  };

  return <Editangle checkRef={checkRef} onClickEditangle={onClickEditangle} />;
};

export default EditangleContainer;
